// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__oI+dH","container":"Footer_container__85h93","logo":"Footer_logo__I8LGM","navList":"Footer_navList__3hn07"};